export default __webpack_public_path__ + "static/media/GMaduroTorpedoOpen.acf86aca.jpg";